export const GAMIFICATION_STATUS_KEYS = {
    BLOCKED: -1, // Blocked
    PENDING: 0, // Pending
    COMPLETE: 1, // Complete
}
export const GAMIFICATION_TYPES_KEYS = {
    GAME: 44, // Game
    CONSTRUCTION: 45, // Construction
    DOT: 46, // Dot
}
